<template>
  <a-layout>
    <a-card :bordered="false">
      <!-- <SmallSquare content='温馨提示：
1、为确保扫码活动正常进行，添加的活动范围请在<a href="/qrcode/batch/index" target="_blank">【应用服务】>【二维码管理】>【码批次管理】</a>中及时开启。（未开启的码无法扫码查询和参与活动，消费者扫码将会提示该码尚未启用！）
2、活动范围中的码存在领奖记录之后，该范围将不能删除，请谨慎操作' :padding='false' class="m-b-20"></SmallSquare> -->
      <div class='mb10 s_flex_ali' v-if="$route.query.type!='detail'">
        <span class='mr15'>
          <a-button type="primary" @click="create">
            <PlusOutlined />
            添加活动范围
          </a-button>
        </span>
      </div>
      <div class="s_c999 mb10"><span class="s_c333">已添加范围列表：</span> （提示：必须添加至少一个范围，所选范围不能重复或重叠）</div>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list' :scroll="{ x: 'max-content'}">
        <template v-slot:action="{ record }">
          <a-popconfirm title="确定要删除该活动么？" @confirm="del(record)" ok-text="删除" cancel-text="取消" placement="topRight" v-if="$route.query.type!='detail'" >
            <a-button type="danger" size="small" href="javascript:;">删除</a-button>
          </a-popconfirm>
        </template>
      </a-table>
      <div  class="s_flex_center">
        <a-button @click="provide()" class="  m-t-20 m-r-20">上一步</a-button>
        <a-button type="primary" @click="save()" class="  m-t-20 ">保存</a-button>
      </div>

    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" v-model:visible="visible" centered :width='700' @ok="handleOk" destroyOnClose :confirm-loading="confirmLoading">
    <a-form ref='ruleForm' :model='form' class="m-t-20" :style="{'marginBottom':'10px'}" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="添加方式" name='add_mode' v-if="false">
        <a-radio-group name="add_mode" v-model:value="form.add_mode">
          <a-radio :value="1">按批次添加</a-radio>
          <a-radio :value="2"><span>
              按出货单号添加
              <a-tooltip placement="right" :get-popup-container="getPopupContainer" :auto-adjust-overflow="false">
                <template #title>
                  <p>1、出货单号是使用防窜货系统出货时产生的，按出货单号可快速添加活动范围；</p>
                  <p>2、若未使用防窜货系统则不能按出货单号添加活动范围。</p>
                </template>
                <QuestionCircleOutlined />
              </a-tooltip>
            </span></a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="可选批次" required help="（可多选，多选时不支持设置流水号）">
        <div class="s_flex_ali m-t-5">
          <div style="border: 1px solid #d9d9d9;border-radius: 2px;padding: 4px 11px;line-height: 1.5715;width:410px">
            <a-tag closable v-for="item in form.batch_sn" :key="item" @close="handleClose(item)">{{item}}</a-tag>
            <p v-if="!form.batch_sn.length">请选择批次</p>
          </div>
          <a-button class="m-l-10" type="primary" @click="visibleCodeBatch=true">选择</a-button>
        </div>
      </a-form-item>
      <div v-if="form.batch_sn.length==1">
        <a-form-item label="设置流水号" name='is_serial' v-if="form.batch_sn">
          <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_serial" />
        </a-form-item>
        <batchInterval pattern="vertical" :small_serial_start="batch.code_start" :small_serial_end="batch.code_end" v-model:start="form.code_start" v-model:end="form.code_end" v-if="form.is_serial" />
        <!-- </a-form-item> -->
        <a-form-item label="区间数量" v-if="form.is_serial&&(form.code_end-form.code_start +1)>0">
          {{form.code_end-form.code_start +1}}
        </a-form-item>
      </div>
      <a-form-item label="备注" name='remarks'>
        <a-textarea v-model:value="form.remarks" placeholder="请输入备注" allow-clear />
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 新增 -->
  <a-modal :keyboard="false" title="选择批次" :width="1200" centered v-model:visible="visibleCodeBatch" :footer="null" destroyOnClose>
    <selectCodeBatchAct @select="batchChange" :selectList="selectList" :checkout="true" :activity_id="activity_id"></selectCodeBatchAct>
  </a-modal>
</template>
<script>
import {
  activitysTwoDel,
  activitysTwoDetail,
  activitysTwoUpdate,
} from "@/api/qrcodeActivitys";
import { PlusOutlined } from "@ant-design/icons-vue";
import { onMounted, reactive, ref, toRefs ,inject} from "vue";
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
const labelCol = { span: 4 };
const wrapperCol = { span: 18 };
const def = {
  add_mode: 1, //暂时只有1
  batch_sn: [],
  is_serial: false, //是否设置起始流水号
  code_start: "", //开启流水号
  code_end: "", //结束流水号
};
let columns = [
  {
    title: "批次",
    dataIndex: "batch_sn",
    key: "batch_sn",
  },
  {
    title: "起始流水号",
    dataIndex: "small_serial_start",
    key: "small_serial_start",
  },
  {
    title: "结束流水号",
    key: "small_serial_end",
    dataIndex: "small_serial_end",
  },
  {
    title: "区间数量",
    dataIndex: "small_code_counts",
    key: "small_code_counts",
  },
  {
    title: "备注",
    dataIndex: "remarks",
    key: "remarks",
  },
  {
    title: "操作",
    key: "action",
    width: 150,
    slots: { customRender: "action" },
  },
];
const rules = {
  add_mode: [
    {
      required: true,
      message: "请选择添加方式",
    },
  ],
  batch_sn: [
    {
       type: 'array',
      required: true,
      message: "请选择批次",
    },
  ],
  small_serial_start: [
    {
      required: true,
      message: "请输入起始流水号",
    },
  ],
  small_serial_end: [
    {
      required: true,
      message: "请输入结束流水号",
    },
  ],
};
export default {
  components: { PlusOutlined },
  props: {
    activity_id: {
      type: Number,
      default: () => {
        return null;
      },
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      visibleCodeBatch:false,
      selectList:[]
    });
    const form = ref(JSON.parse(JSON.stringify(def)));
    const ruleForm = ref();
    const listLoading = ref(true);
    const list = ref([]);
    const visible = ref(false);
    const confirmLoading = ref(false)
    const create=()=>{
      visible.value=true;
      batch.value = {}
      state.selectList = []
      form.value={
          add_mode: 1, //暂时只有1
          batch_sn: [],
          is_serial: false, //是否设置起始流水号
          code_start: "", //开启流水号
          code_end: "", //结束流水号
      };
    }
    // 获取详情
    const detail = async () => {
      listLoading.value = true;
      let result = await activitysTwoDetail(props.activity_id)
        .then((res) => res.data)
        .catch((error) => error);
      listLoading.value = false;
      console.log(result);
      if (iscode(result)) {
        list.value = result.data;
      } else {
        message.error(result.message);
      }
    };
    // 下一步
    const $router=inject('$router')
    const save = () => {
      $router.go(-1)
    };
    const provide = () => {
      emit("setpsTwoProvide", 1);
    };
    // 删除
    const del = async (data) => {
      let result = await activitysTwoDel(data.id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        detail();
      }
    };
    // 新增范围
    const handleOk = () => {
      ruleForm.value.validate().then(async (res) => {
        confirmLoading.value = true
        let result = await activitysTwoUpdate(props.activity_id, {
          ...form.value
        })
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result, true)) {
          detail();
          visible.value = false;
        }
        
        confirmLoading.value = false
      });
    };
    // 用于记录 选中的批次 数据
    const batch = ref({});
    const batchChange = (data) => {
      console.log(data)
      state.selectList = data;
      batch.value = data[0];
      form.value.batch_sn = data.map(v=>v.batch_sn);
      state.visibleCodeBatch = false;
    };
    const handleClose = (e) =>{
      var tags = form.value.batch_sn.filter(v => v !== e);
      state.selectList = state.selectList.filter(v => v.batch_sn !== e);
      form.value.batch_sn = tags;
      if(tags.length===1){
        batch.value = state.selectList[0];  
      }
      if(!tags.length){
        batch.value = {}
        state.selectList = []
      }
    }

    onMounted(() => {
      detail();
    });
    return {
      ...toRefs(state),
      create,
      columns,
      listLoading,
      list,
      form,
      rules,
      ruleForm,
      labelCol,
      wrapperCol,
      del,
      handleOk,
      detail,
      save,
      provide,
      visible,
      batch,
      batchChange,
      def,
      confirmLoading,
      handleClose
    };
  },
};
</script>